import React, { useState, useRef } from 'react';
import whyChooseVid from '../../assets/images/videoplayback.mp4'
import { FaPlay } from "react-icons/fa6";
import { CgClose } from "react-icons/cg";
import { BsFillBookmarkStarFill, BsTrophyFill } from "react-icons/bs";
import { FaPersonChalkboard, FaUsersRectangle, FaUsers } from "react-icons/fa6";
import { PiUserFocusFill } from "react-icons/pi";
import { GiSchoolBag } from "react-icons/gi";

const WhyChoose = () => {
    const [isVideoPopupVisible, setVideoPopupVisible] = useState(false);
    const videoRef = useRef(null);

    // Function to handle showing the video popup
    const handleVideoPopup = () => {
        setVideoPopupVisible(true);

        // Wait until the popup is visible, then play the video
        setTimeout(() => {
            videoRef.current?.play().catch((err) => {
                console.error("Video playback failed:", err);
            });
        }, 100); // Delay to ensure the DOM update for visibility
    };

    // Function to handle closing the video popup
    const handleClosePopup = () => {
        setVideoPopupVisible(false);
        if (videoRef.current) {
            videoRef.current.pause();
            videoRef.current.currentTime = 0; // Reset video position
        }
    };
    return (
        <>
            {isVideoPopupVisible && (
                <div className="whyChooseVideoPopup">
                    <div className="closeWhyChooseVideoPopup" onClick={handleClosePopup}>
                        <CgClose />
                    </div>
                    <div className="whyChooseVideoPopupVideo">
                        <video
                            ref={videoRef}
                            playsInline
                            controls
                            preload="auto"
                            className="popupVideo"
                        >
                            <source src={whyChooseVid} type="video/mp4" />
                        </video>
                    </div>
                </div>
            )}
            <section id='whyChoose'>
                <div className="container">
                    <h2 className='title'>Why Choose Neethus</h2>
                    <p className="desc">Premier Choice for Language Proficiency & Test Preparation</p>
                    <div className="whyChooseMain">
                        <div className="whyChooseThumbnail" onClick={handleVideoPopup}>
                            <div className="whyChooseThumbnailBanner">
                                <div className="whyChooseThumbnailBannerIcon">
                                    <FaPlay />
                                </div>
                            </div>
                        </div>
                        <div className="whyChooseDetails">
                            <h3>Industry leading coaching nearby</h3>
                            <p className="desc">Our reputation in delivering high quality teaching with a wide range of packages is at the pinnacle for a student to choose.</p>
                            <ul>
                                <li>
                                    <div className="icon">
                                        <BsFillBookmarkStarFill />
                                    </div>
                                    <div className="details">
                                        <h4>Expertise & Specialization</h4>
                                        <h6>Specialized courses with expert instructors for targeted and effective learning strategies.</h6>
                                    </div>
                                </li>
                                <li>
                                    <div className="icon">
                                        <BsTrophyFill />
                                    </div>
                                    <div className="details">
                                        <h4>Proven Success</h4>
                                        <h6>Strong track record of helping students achieve high scores and language proficiency</h6>
                                    </div>
                                </li>
                                <li>
                                    <div className="icon">
                                        <FaPersonChalkboard />
                                    </div>
                                    <div className="details">
                                        <h4>Quality Instruction</h4>
                                        <h6>Student-centric approach to ensure comprehensive understanding and practical exam strategies.</h6>
                                    </div>
                                </li>
                                <li>
                                    <div className="icon">
                                        <PiUserFocusFill />
                                    </div>
                                    <div className="details">
                                        <h4>Individual Attention</h4>
                                        <h6>Personalized support through one-on-one sessions, small group classes, and tailored study plans</h6>
                                    </div>
                                </li>
                                <li>
                                    <div className="icon">
                                        <FaUsersRectangle />
                                    </div>
                                    <div className="details">
                                        <h4>Flexible Learning Options</h4>
                                        <h6>Online and offline courses, allowing students to balance their studies with other commitments</h6>
                                    </div>
                                </li>
                                <li>
                                    <div className="icon">
                                        <GiSchoolBag />
                                    </div>
                                    <div className="details">
                                        <h4>Comprehensive Resources</h4>
                                        <h6>Access to up-to-date study materials and practice exams, enhancing learning experience and exam readiness</h6>
                                    </div>
                                </li>
                                <li>
                                    <div className="icon">
                                        <FaUsers />
                                    </div>
                                    <div className="details">
                                        <h4>Supportive Community</h4>
                                        <h6>Supportive environment where students can network, share experiences, and benefit from peer support</h6>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default WhyChoose;